/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface WithPrice
 */
export interface WithPriceOptional {
  /**
   *
   * @type {number}
   * @memberof WithPrice
   */
  price?: number;
}

export interface WithPrice extends WithPriceOptional {
  /**
   *
   * @type {number}
   * @memberof WithPrice
   */
  price?: number;
}

export interface WithPriceTrackedI {
  /**
   *
   * @type {number}
   * @memberof WithPrice
   */
  price?: number;
  priceIsSet: boolean;
}

transformDatesMap.set("WithPrice", function (model: WithPrice) {});

export type WithPriceMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
}>;

export var WithPriceMeta: WithPriceMetaI = {} as WithPriceMetaI;
WithPriceMeta = typeMeta("WithPrice", {
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
});

const metaI = WithPriceMeta;

registerMeta(() => {});

export class WithPriceTracked implements WithPriceTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  constructor(config?: WithPriceOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: WithPriceOptional,
    options?: AssignOptions,
  ): WithPriceTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): WithPriceTrackedI {
    const cloned = {} as WithPriceTrackedI;
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): WithPriceTrackedI {
    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    return this;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(WithPriceMeta.price, WithPriceMeta, this.price, this);
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.priceIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
